import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "ml-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-primary text-h5"
}

import { ref, computed } from "vue";
import { apiQuery } from "@/api/j24api";
import AppIcon from "./AppIcon.vue";
import { patch24Store } from "@/stores/patch24";
import { storeToRefs } from "pinia";
import AlertsList from "@/components/AlertsList.vue";
import { permissionsStore } from "@/stores/permissions";
interface Inventory {
  CFBundleVersion: string;
  path: string;
  CFBundleIdentifier: string;
  CFBundleIconFile: string;
  fromMacAppStore: boolean;
  CFBundleShortVersionString: string;
}

interface PatchUpdate {
  status: string;
  version: string;
  expedite: boolean;
  appID: string;
  inventory: Inventory;
  type: string;
}

export interface PatchCommand {
  _id: string;
  licenseId: string;
  serial: string;
  type: string;
  status: string;
  appId: string;
  version: string;
  created: string; // ISO date string
  createdBy: string;
  __v: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PatchesAvailable',
  props: {
    updates: {},
    loading: { type: Boolean },
    commands: {},
    serialNumber: {}
  },
  emits: ["cancel-command", "update-commands"],
  setup(__props: any, { emit: __emit }) {

const patch24 = patch24Store();
const { appsList, selectedLicense } = storeToRefs(patch24);
const permissions = permissionsStore();

const props = __props;

const emit = __emit;

const showDeleteDialog = ref(false);
const commandToDelete = ref<PatchCommand | null>(null);
const showCreateDialog = ref(false);
const selectedPatch = ref<PatchUpdate | null>(null);
const selectedCommandType = ref("installSoon");
const loadingCreate = ref(false);

const readOnlyMode = computed(() => {
  let result =
    permissions.$state &&
    permissions.$state["PatchingV2-Commands"] &&
    permissions.$state["PatchingV2-Commands"].actions.includes("Create");
  return !result;
});

const headers = [
  { title: "App Name", value: "appID" },
  { title: "Version", value: "version" },
  { title: "Status", value: "status" },
  { title: "Actions", value: "actions" },
];

function mapStatusToText(status: string) {
  switch (status) {
    case "ReadyToInstall":
      return "Ready to Install";
    case "NotDownloaded":
      return "Not Downloaded";
    case "Downloading":
      return "Downloading";
    case "FailedToDownload":
      return "Failed to Download";
    case "Installing":
      return "Installing";
    case "FailedToInstall":
      return "Failed to Install";
    case "Installed":
      return "Installed";
    default:
      return status;
  }
}

function mapStatusToColor(status: string) {
  switch (status) {
    case "ReadyToInstall":
      return "blue";
    case "NotDownloaded":
      return "grey";
    case "Downloading":
      return "cyan";
    case "FailedToDownload":
      return "orange";
    case "Installing":
      return "purple";
    case "FailedToInstall":
      return "red";
    case "Installed":
      return "green";
    default:
      return "grey";
  }
}

function mapCommandTypeToText(type: string) {
  switch (type) {
    case "installSoon":
      return "Install Soon";
    case "installASAP":
      return "Install ASAP";
    default:
      return type;
  }
}
function doesPatchCommandExist(patch: PatchUpdate) {
  const found = props.commands.find(
    (cmd) => cmd.appId === patch.appID && cmd.version === patch.version
  );
  if (found) {
    return { ...found, typeText: mapCommandTypeToText(found.type) };
  } else {
    return null;
  }
}

function confirmDeleteCommand(item: PatchCommand) {
  commandToDelete.value = item;
  showDeleteDialog.value = true;
}

function cancelCommand() {
  if (commandToDelete.value) {
    emit("cancel-command", commandToDelete.value);
    showDeleteDialog.value = false;
    commandToDelete.value = null;
  }
}

function confirmCreatePatchCommand(item: PatchUpdate) {
  selectedPatch.value = item;
  showCreateDialog.value = true;
}
//MARK: Create Patch Command
async function createPatchCommand() {
  loadingCreate.value = true;
  if (!selectedPatch.value) {
    console.error("No patch selected.");
    return;
  }

  console.log(
    "Creating patch command for:",
    selectedPatch.value,
    "Type:",
    selectedCommandType.value
  );
  try {
    let result = await apiQuery("ELA", "patching/patchingManagement", {
      action: "addDeviceCommand",
      licenseId: selectedLicense.value!._id,
      serial: props.serialNumber,
      type: selectedCommandType.value,
      appId: selectedPatch.value.appID,
      version: selectedPatch.value.version,
      status: "pending",
    });
    console.log("Patch command created:", result);
    // getData(props.device); // Refresh device data (uncomment if getData is defined)
    showCreateDialog.value = false;
    emit("update-commands");
  } catch (error) {
    console.error("Error creating patch command:", error);
  }
  loadingCreate.value = false;
}

function getAppName(appId: string) {
  const app = appsList.value.find((app: { id: string }) => app.id === appId);
  return app ? app.name : "Unknown App";
}

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_sheet, {
      rounded: "lg",
      elevation: "1",
      class: "ma-1"
    }, {
      default: _withCtx(() => [
        _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "ml-3 pt-2" }, "Patches Available", -1)),
        _createVNode(_component_v_data_table, {
          headers: headers,
          items: props.updates,
          loading: props.loading,
          "hide-default-footer": "",
          "no-data-text": "No Patches Outstanding"
        }, {
          [`item.appID`]: _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(AppIcon, {
                appID: item.appID,
                width: 30,
                height: 30,
                style: {"max-width":"30px","max-height":"30px"}
              }, null, 8, ["appID"]),
              _createElementVNode("span", _hoisted_2, _toDisplayString(getAppName(item.appID)), 1)
            ])
          ]),
          [`item.status`]: _withCtx(({ item }) => [
            _createVNode(_component_v_chip, {
              color: mapStatusToColor(item.status),
              dark: "",
              small: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(mapStatusToText(item.status)), 1)
              ]),
              _: 2
            }, 1032, ["color"])
          ]),
          [`item.actions`]: _withCtx(({ item }) => [
            (doesPatchCommandExist(item))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_v_chip, {
                    color: "primary",
                    dark: "",
                    small: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Patch Command Set: " + _toDisplayString(doesPatchCommandExist(item)?.typeText), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (!readOnlyMode.value)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        variant: "plain",
                        icon: "mdi-delete",
                        color: "primary",
                        onClick: ($event: any) => (confirmDeleteCommand(doesPatchCommandExist(item)!))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tooltip, {
                    activator: "parent",
                    location: "top"
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("Delete Command")
                    ])),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  size: "small",
                  color: "primary",
                  onClick: ($event: any) => (confirmCreatePatchCommand(item))
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("Install")
                  ])),
                  _: 2
                }, 1032, ["onClick"]))
          ]),
          _: 2
        }, 1032, ["items", "loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: showDeleteDialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDeleteDialog).value = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _cache[11] || (_cache[11] = _createElementVNode("h2", null, "Delete Patch Command", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "mt-3" }, " Are you sure you want to delete this patch command? ", -1)),
                _createVNode(_component_v_row, { class: "mt-5" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "auto",
                      class: "pr-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          variant: "elevated",
                          onClick: cancelCommand
                        }, {
                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                            _createTextVNode("Delete")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "auto" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "elevated",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (showDeleteDialog.value = false))
                        }, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createTextVNode("Cancel")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_spacer)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showCreateDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showCreateDialog).value = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        (selectedPatch.value)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _cache[15] || (_cache[15] = _createElementVNode("h1", null, "Patch Command", -1)),
                    (selectedPatch.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(getAppName(selectedPatch.value.appID)), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_text_field, {
                      class: "mt-3",
                      variant: "underlined",
                      readonly: "",
                      label: "Version:",
                      modelValue: selectedPatch.value.version,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedPatch.value.version) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_select, {
                      modelValue: selectedCommandType.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedCommandType).value = $event)),
                      items: [
            { text: 'Install Soon', value: 'installSoon' },
            { text: 'Install ASAP', value: 'installASAP' },
          ],
                      label: "Command Type:",
                      "item-title": "text",
                      "item-value": "value",
                      variant: "underlined",
                      dense: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "auto",
                          class: "pr-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              loading: loadingCreate.value,
                              color: "primary",
                              variant: "elevated",
                              onClick: createPatchCommand
                            }, {
                              default: _withCtx(() => _cache[13] || (_cache[13] = [
                                _createTextVNode("Create Command")
                              ])),
                              _: 1
                            }, 8, ["loading"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "auth" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              variant: "elevated",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (showCreateDialog.value = false))
                            }, {
                              default: _withCtx(() => _cache[14] || (_cache[14] = [
                                _createTextVNode("Cancel")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})